import React from 'react';
import {FormattedMessage} from 'react-intl';

import StatusTab from "./component/StatusTab";

import useStatusTabs from "./useStatusTabs";
import {STATUS_TABS} from "./statusTabsConfig";

import {greyishBlue100} from "assets/jss/main";

function StatusesTab() {
    const {statusSelected, countRetrieved, loading, handleSelectStatus} = useStatusTabs();

    return (
        <div style={{
            display: 'flex',
            gap: '24px',
            borderBottom: `1px solid ${greyishBlue100}`,
            marginTop: '32px',
            marginBottom: '32px'
        }}>
            {STATUS_TABS.map(({status, countKey, labelId, theme, badgeTextColor}) => (
                <StatusTab
                    key={status}
                    label={<FormattedMessage id={labelId}/>}
                    count={countRetrieved[countKey] ?? 0}
                    theme={theme}
                    badgeTextColor={badgeTextColor}
                    selected={statusSelected === status}
                    onClick={() => handleSelectStatus(status)}
                    loading={loading}
                />
            ))}
        </div>
    );
}

export default StatusesTab;
